import http from "../http-common";

class ElectronicInvoicesService {
    /**
     * Đồng bộ danh sách mẫu hóa đơn từ nguồn Viettel qua BE
     */
    syncInvoiceTemplateList(data) {
        return http.post(`/electronic-invoice/get-all-invoice`, data);
    }

    /**
     * Tạo hóa đơn cloud
     */
    createElectronicInvoice(data) {
        return http.post(`/electronic-invoice/create-invoice`, data);
    }

    /**
     * Tạo hóa đơn usb token
     */
    createInvoiceUsbToken(data) {
        return http.post(`/electronic-invoice/create-invoice-by-usb-token`, data);
    }

    /**
     * Tạo hóa đơn nháp
     */
    createDraftInvoice(data) {
        return http.post(`/electronic-invoice/create-draft-invoice`, data);
    }

    /**
     * Lưu hóa đơn nháp phía onekids
     */
    createDraftOneKidsInvoice(data) {
        return http.post(`/electronic-invoice/create-draft-onekids-invoice`, data);
    }

    /**
     * Lưu nhiều hóa đơn nháp phía onekids
     */
    createMultiDraftOneKidsInvoice(data) {
        return http.post(`/electronic-invoice/create-multi-draft-onekids-invoice`, data);
    }

    /**
     * Cập nhật hóa đơn nháp phía onekids
     */
    updateDraftOneKidsInvoice(data, transactionUuid) {
        return http.post(`/electronic-invoice/update-draft-onekids-invoice/${transactionUuid}`, data);
    }

    /**
     * Xem trước hóa đơn -> trả về file PDF (arraybuffer)
     */
    previewInvoice(data) {
        return http.post(`/electronic-invoice/preview-invoice`, data, {responseType: 'arraybuffer'});
    }

    /**
     * Xem trước hóa đơn -> trả về file PDF (arraybuffer)
     */
    previewInvoiceFromDraft(data) {
        return http.post(`/electronic-invoice/preview-invoice-from-draft`, data, {responseType: 'arraybuffer'});
    }

    /**
     * Quản lý hóa đơn học phí: lọc theo tháng/trạng thái/khối/lớp/từ khóa + phân trang
     */
    searchInvoiceManagement(month, year, kidStatus, idClass, idGrade, kidName, invoiceStatus, invoicePurpose, page, limit) {
        return http.get(`/electronic-invoice/invoices`, {
            params: {
                month,
                year,
                kidStatus,
                idClass,
                idGrade,
                kidName,
                invoiceStatus,
                invoicePurpose,
                page,
                limit
            }
        });
    }

    /**
     * Quản lý hóa đơn khác: lọc theo tháng/trạng thái/khối/lớp/từ khóa + phân trang
     */
    searchInvoiceManagementOther(month, year, invoiceStatus, invoicePurpose, page, limit) {
        return http.get(`/electronic-invoice/invoices`, {
            params: {
                month,
                year,
                invoiceStatus,
                invoicePurpose,
                page,
                limit
            }
        });
    }

    /**
     * Tạo hóa đơn nháp từ nháp onekids
     */
    createDraftInvoiceFromDraft(data) {
        return http.post(`/electronic-invoice/create-draft-viettel-from-draft`, data);
    }

    /**
     * Tạo nhiều hóa đơn nháp từ nháp onekids
     */
    createMultiDraftInvoiceFromDraft(data) {
        return http.post(`/electronic-invoice/multi-create-draft-viettel-from-draft`, data);
    }


    /**
     * Tạo hóa đơn nháp từ nháp onekids bằng USB token
     */
    createDraftInvoiceFromDraftByUsbToken(data) {
        return http.post(`/electronic-invoice/create-draft-viettel-from-draft-by-usb-token`, data);
    }

    /**
     * Tạo hóa đơn từ nháp onekids cloud
     */
    createInvoiceFromDraft(data) {
        return http.post(`/electronic-invoice/create-invoice-from-draft`, data);
    }

    /**
     * Tạo hóa đơn từ nháp onekids bằng USB token
     */
    createInvoiceFromDraftByUsbToken(data) {
        return http.post(`/electronic-invoice/create-invoice-by-usb-token-from-draft`, data);
    }

    /**
     * Xóa hóa đơn theo transactionUuid
     */
    deleteMultiInvoice(data) {
        return http.post(`/electronic-invoice/delete-multi-invoice`, data);
    }


    /**
     * Xem trước hóa đơn -> trả về file PDF (arraybuffer)
     */
    downloadInvoice(data) {
        return http.post(`/electronic-invoice/download`, data, {responseType: 'arraybuffer'});
    }

    /**
     * Tạo nhiều hóa đơn cloud
     */
    createMultiInvoiceFromDraft(data) {
        return http.post(`/electronic-invoice/create-multi-invoice-from-draft`, data);
    }

    /**
     * Tạo nhiều hóa đơn từ draft bằng USB token
     */
    createMultiInvoiceFromDraftByUsbToken(data) {
        return http.post(`/electronic-invoice/create-multi-invoice-from-draft-by-usb"`, data);
    }

    /**
     * Gửi nhiều hóa đơn sang cơ quan thuế
     */
    sendMultiInvoiceAuthorities(data) {
        return http.post(`/electronic-invoice/send-multi-invoice-authorities`, data);
    }

    /**
     * Cập nhật trạng thái phát hành hóa đơn
     */
    syncToTaxAuthorities() {
        return http.post(`/electronic-invoice/sync-invoice-authorities-status`);
    }
    /**
     * Cập nhật trạng thái hóa đơn nháp
     */
    syncToTaxAuthoritiesOnekidsDraft(data = {}) {
        const request = {
            month: Number.isInteger(data.month) ? data.month : 0,
            year: Number.isInteger(data.year) ? data.year : 0,
            draftStatusAllTime: !!data.draftStatusAllTime,
        };
        return http.post(`/electronic-invoice/sync-invoice-draft-authorities-status`, request);
    }

    /**
     * Cập nhật trạng thái thanh toán hóa đơn: chưa thanh toán -> đã thanh toán
     */
    updateInvoicePaymentStatus(data) {
        return http.post(`/electronic-invoice/update-invoice-status`, data);
    }

    /**
     * Cập nhật trạng thái thanh toán hóa đơn: đã thanh toán -> chưa thanh toán
     */
    cancelInvoicePaymentStatus(data) {
        return http.post(`/electronic-invoice/cancel-invoice-status`, data);
    }

    /**
     * Gửi thông báo hóa đơn điện tử qua app cho học sinh
     */
    createOrderExcelNotifyForApp(data) {
        return http.post(`/electronic-invoice/notify/app`, data);
    }


}

export default new ElectronicInvoicesService();